import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import ContactForm from "./../ContactForm/ContactForm";
import './Contact.css';
import Header from '../../Shared/Header/Header';
import Footer from '../../Shared/Footer/Footer';
import { useApp } from '../../../contexts/AppContext';

const Contact = () => {
   const { isInitialLoad, setIsInitialLoad } = useApp();

   useEffect(() => {
     if (isInitialLoad) return;
     setIsInitialLoad(true);
   }, [isInitialLoad, setIsInitialLoad]);
  
    return (
      <>
        <Header></Header>
        <motion.div
          className='my-5'
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 2 }}
        >
          <h1 className='fw-bold'>Get in touch</h1>

          <p>
            Want to get in touch? I would love to hear from you. Here's how you
            can reach me...
          </p>

          <hr className='horizontal-line' />
          <ContactForm></ContactForm>
        </motion.div>
        <Footer></Footer>
      </>
    );
};

export default Contact;